import { gql } from 'graphql-request'

export namespace HomeIssueMutations {
  export function createHomeIssue() {
    return gql`
      mutation createHomeIssue(
        $homeIssue: HomeIssueInsertMutation
        $attachments: [Upload!]
        $geolocation: GeolocationInput
      ) {
        createHomeIssue(homeIssue: $homeIssue, attachments: $attachments, geolocation: $geolocation) {
          id
          createdAt
          homeInventoryItem {
            name
          }
          homeLocation
          notes
          type
        }
      }
    `
  }

  export function resolveHomeIssue() {
    return gql`
      mutation resolveHomeIssue($homeIssueId: Int!, $geolocation: GeolocationInput) {
        resolveHomeIssue(homeIssueId: $homeIssueId, geolocation: $geolocation) {
          id
        }
      }
    `
  }

  export function updateHomeIssue() {
    return gql`
      mutation updateHomeIssue($homeIssue: HomeIssueUpdateMutation) {
        updateHomeIssue(homeIssue: $homeIssue) {
          id
        }
      }
    `
  }
}
